import {
  add,
  endOfMonth,
  getDate,
  isValid,
  set,
  startOfDay
} from '@sequencehq/utils/dates'

export const getLatestRecurrenceDate =
  (recurrenceDayOfMonth: number) => (dateToCheck: Date) => {
    if (!isValid(dateToCheck)) {
      return undefined
    }

    const dateOfStart = getDate(dateToCheck)

    if (dateOfStart < recurrenceDayOfMonth) {
      const endOfPreviousMonth = new Date(
        endOfMonth(add(dateToCheck, { months: -1 }))
      )
      const endOfPreviousMonthDate = getDate(endOfPreviousMonth)

      const newDate = set(endOfPreviousMonth, {
        date:
          recurrenceDayOfMonth < endOfPreviousMonthDate
            ? recurrenceDayOfMonth
            : endOfPreviousMonthDate
      })

      /**
       * Set the time of day to 00:00:00 to avoid any weirdness around `isEqual` as we want a consistent time
       * part of the date for comparison
       */
      return startOfDay(newDate)
    }

    if (dateOfStart === recurrenceDayOfMonth) {
      return dateToCheck
    }

    const newDate = set(dateToCheck, {
      date: recurrenceDayOfMonth
    })

    /**
     * Set the time of day to 00:00:00 to avoid any weirdness around `isEqual` as we want a consistent time
     * part of the date for comparison
     */
    return startOfDay(newDate)
  }
